module.exports = __webpack_public_path__ + "img/ocean-hotel-3.e4c79c4a.jpg";